import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

interface RecentUpdateFilterState {
  loading: boolean
}

@Injectable()
export class RecentUpdateFilterLocalStoreService extends ComponentStore<RecentUpdateFilterState> {

  public readonly loading$ = this.select(state =>
      state.loading);

  constructor() {
    super({
      loading: false
    })
  }

  readonly updateLoading = this.updater((state,
                                         loading: boolean): RecentUpdateFilterState =>
      ({...state, loading: loading}));
}
